import { Pipe, PipeTransform } from '@angular/core';
import { PromoQualification } from '../Model/PromoQualification.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'PromoQualificationFilter',
  standalone: false
})
export class PromoQualificationFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(promoQualifications: PromoQualification[], searchTerm: string, field: string): PromoQualification[] {
    if (!promoQualifications || !searchTerm) return promoQualifications;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return promoQualifications.filter(promo =>
      this.dateMatches(promo.deliveryStartDate, lowerSearchTerm) ||
      this.dateMatches(promo.deliveryEndDate, lowerSearchTerm) ||
      (promo.dataQualityLabel?.toLowerCase().includes(lowerSearchTerm) ?? false)
    );
  }

  private dateMatches(date: string | number | Date | null | undefined, term: string): boolean {
    if (!date) return false;
    const formattedDate = this.datePipe.transform(date as string | number | Date, 'MMMM dd, yyyy');
    return formattedDate?.toLowerCase().includes(term) ?? false;
  }
}
